import { c as _c } from "react/compiler-runtime";
import type { Maybe } from '@/modules/__generated__/graphql/switchboard-generated';
import { SubmitRequestForm } from './submit-request-form';
import { SummaryCard } from './summary-card';
interface SummaryStepProps {
  templateTitle?: string;
  templateSubtitle?: Maybe<string>;
}
function SummaryStep(t0) {
  const $ = _c(6);
  const {
    templateTitle,
    templateSubtitle
  } = t0;
  let t1;
  if ($[0] !== templateSubtitle || $[1] !== templateTitle) {
    t1 = <SummaryCard templateTitle={templateTitle} templateSubtitle={templateSubtitle} />;
    $[0] = templateSubtitle;
    $[1] = templateTitle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="lg:sticky lg:top-28"><SubmitRequestForm /></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <div className="mt-6 flex flex-col-reverse gap-6 lg:grid lg:grid-cols-[3fr_2fr] lg:items-start">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export { SummaryStep };